import { render, staticRenderFns } from "./DraggableTable.vue?vue&type=template&id=47b8c8b4&scoped=true"
import script from "./DraggableTable.vue?vue&type=script&lang=js"
export * from "./DraggableTable.vue?vue&type=script&lang=js"
import style0 from "./DraggableTable.vue?vue&type=style&index=0&id=47b8c8b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b8c8b4",
  null
  
)

export default component.exports